import { render } from "./BackButton.vue?vue&type=template&id=acd9c78a&scoped=true"
const script = {}

import "./BackButton.vue?vue&type=style&index=0&id=acd9c78a&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acd9c78a"]])

export default __exports__